import html from './404.html';
import {Router} from "horizon-js-front-sdk/lib/Router";

Router.getMainRouter()?.injectPageHtml(html);